import { RootState } from 'app/rootReducer';
import { userInRole } from 'features/auth/Roles';
import { DocumentsPage } from 'features/pages/DocumentsPage';
import React from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';

import RoleOnlyRoute from '../auth/RoleOnlyRoute';
import { Allreports } from '../pages/AllReports';
import { Dashboard } from '../pages/Dashboard';
import { DataUploadPage } from '../pages/DataUploadPage';
import { FAQPage } from '../pages/FAQPage';
import { ReportPage } from '../pages/ReportPage';
import { MainLayout } from '../pages/layouts/MainLayout';

const AppRoutes: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.auth);

  return (
    <MainLayout>
      <Routes>
        {userInRole(user, 'view') && (
          <Route path=''>
            <Navigate to='/app/reports' />
          </Route>
        )}
        {userInRole(user, 'upload') && (
          <Route path=''>
            <Navigate to='/app/data-delivery' />
          </Route>
        )}
        {userInRole(user, 'documents') && (
          <Route path=''>
            <Navigate to='/app/documents' />
          </Route>
        )}
        {userInRole(user, 'admin') && (
          <Route path=''>
            <Navigate to='/app/dashboard' />
          </Route>
        )}
        <Route path='dashboard'>
          <Dashboard />
        </Route>
        <RoleOnlyRoute path='data-delivery' roles={['upload']}>
          <DataUploadPage />
        </RoleOnlyRoute>
        <RoleOnlyRoute path='documents' roles={['documents']}>
          <DocumentsPage />
        </RoleOnlyRoute>
        <Route path='data-delivery/:id'>
          <DataUploadPage />
        </Route>
        <RoleOnlyRoute path='reports' roles={['view']}>
          <Allreports />
        </RoleOnlyRoute>
        <Route path='reports/:id'>
          <ReportPage />
        </Route>
        <Route path='faq'>
          <FAQPage />
        </Route>
      </Routes>
    </MainLayout>
  );
};

export default AppRoutes;
